<template>
  <Form
    ref="areaForm"
    :model="queryData"
    inline
    :label-width="125"
    class="form-common"
  >
    <Row>
      <FormItem
        label="产品名称"
        prop="skuCode"
      >
        <SkuInput
          v-model="queryData.skuCode"
          :name.sync="queryData.skuName"
        />
        <Button
          v-if="queryData.skuCode"
          @click="clickClean"
        >清空</Button>
      </FormItem>
      <FormItem
        label="批次号"
        prop="pici"
      >
        <Input
          type="text"
          v-model="queryData.pici"
          placeholder="请输入批次号"
        >
        </Input>
      </FormItem>
    </Row>
    <FormItem class="btn-groups">
      <Button
        type="primary"
        @click="handleQuery"
      >查询</Button>
      <!--<Button type="default" @click="handleReset('areaForm')">重置</Button>-->
      <Button
        type="default"
        @click="clickInsert"
      >新增</Button>
    </FormItem>
  </Form>
</template>

<script>
import SkuInput from '@/components/SkuInput/index.vue'
export default {
  name: 'QueryForm',
  components: {
    SkuInput
  },
  data () {
    return {
      queryData: {
        skuName: '',
        skuCode: '',
        pici: '',
      }
    }
  },
  created () {

  },
  methods: {
    handleQuery () {
      this.$emit('on-query',this.queryData)
    },
    setQueryData (data) {
      this.queryData=data
    },
    clickInsert () {
      this.$emit('on-insert')
    },
    clickClean () {
      this.queryData.skuCode=''
      this.queryData.skuName=''
    }
  }
}
</script>
